<div class="finance-dashboard">
  <!-- Welcome Section -->
  <div class="row mb-4">
    <div class="col-12">
      <div class="welcome-card">
        <div class="welcome-content">
          <h2 class="welcome-title">
            <i class="fa fa-calculator me-2"></i>
            Finance Dashboard
          </h2>
          <p class="welcome-subtitle">
            Welcome back, {{ user?.firstName }} {{ user?.lastName }}!
            <br>
            <small class="text-muted">Manage invoices and financial reports</small>
          </p>
        </div>
        <div class="welcome-icon">
          <i class="fa fa-chart-line"></i>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading State -->
  <div *ngIf="isLoading" class="text-center py-5">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-3">Loading dashboard data...</p>
  </div>

  <!-- Dashboard Content -->
  <div *ngIf="!isLoading">
    <!-- Statistics Cards -->
    <!-- <div class="row mb-4">
      <div class="col-lg-3 col-md-6 mb-3">
        <div class="stat-card stat-card-primary">
          <div class="stat-icon">
            <i class="fa fa-file-invoice"></i>
          </div>
          <div class="stat-content">
            <h3 class="stat-number">{{ dashboardStats.totalInvoices | number }}</h3>
            <p class="stat-label">Total Invoices</p>
          </div>
        </div>
      </div>
      
      <div class="col-lg-3 col-md-6 mb-3">
        <div class="stat-card stat-card-warning">
          <div class="stat-icon">
            <i class="fa fa-clock"></i>
          </div>
          <div class="stat-content">
            <h3 class="stat-number">{{ dashboardStats.pendingInvoices | number }}</h3>
            <p class="stat-label">Pending Invoices</p>
          </div>
        </div>
      </div>
      
      <div class="col-lg-3 col-md-6 mb-3">
        <div class="stat-card stat-card-success">
          <div class="stat-icon">
            <i class="fa fa-check-circle"></i>
          </div>
          <div class="stat-content">
            <h3 class="stat-number">{{ dashboardStats.completedInvoices | number }}</h3>
            <p class="stat-label">Completed Invoices</p>
          </div>
        </div>
      </div>
      
      <div class="col-lg-3 col-md-6 mb-3">
        <div class="stat-card stat-card-info">
          <div class="stat-icon">
            <i class="fa fa-rupee-sign"></i>
          </div>
          <div class="stat-content">
            <h3 class="stat-number">{{ formatCurrency(dashboardStats.totalRevenue) }}</h3>
            <p class="stat-label">Total Revenue</p>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Quick Actions and Recent Activity -->
    <div class="row">
      <!-- Quick Actions -->
      <!-- <div class="col-lg-4 mb-4"> -->
        <div class="card h-100">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fa fa-bolt me-2"></i>Quick Actions
            </h5>
          </div>
          <div class="card-body">
            <div class="quick-actions">
              <a *ngFor="let action of quickActions" 
                 [routerLink]="action.route"
                 class="quick-action-item"
                 [class]="'quick-action-' + action.color">
                <div class="quick-action-icon">
                  <i class="fa" [class]="action.icon"></i>
                </div>
                <div class="quick-action-content">
                  <h6 class="quick-action-title">{{ action.title }}</h6>
                  <p class="quick-action-desc">{{ action.description }}</p>
                </div>
                <div class="quick-action-arrow">
                  <i class="fa fa-chevron-right"></i>
                </div>
              </a>
            </div>
          </div>
        <!-- </div> -->
      </div>

      <!-- Recent Invoices -->
      <!-- <div class="col-lg-8 mb-4">
        <div class="card h-100">
          <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="card-title mb-0">
              <i class="fa fa-history me-2"></i>Recent Invoices
            </h5>
            <a routerLink="/reports/certificate-report" class="btn btn-sm btn-outline-primary">
              View All
            </a>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table table-hover">
                <thead class="table-light">
                  <tr>
                    <th>Invoice ID</th>
                    <th>Dealer</th>
                    <th>Amount</th>
                    <th>Status</th>
                    <th>Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let invoice of dashboardStats.recentInvoices">
                    <td>
                      <span class="fw-bold">{{ invoice.id }}</span>
                    </td>
                    <td>{{ invoice.dealer }}</td>
                    <td>{{ formatCurrency(invoice.amount) }}</td>
                    <td>
                      <span [class]="getStatusClass(invoice.status)">
                        {{ invoice.status }}
                      </span>
                    </td>
                    <td>
                      <small class="text-muted">
                        {{ invoice.date | date:'MMM dd, yyyy' }}
                      </small>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div> -->
    </div>

    <!-- Monthly Revenue Chart Placeholder -->
    <!-- <div class="row">
      <div class="col-12 mb-4">
        <div class="card">
          <div class="card-header">
            <h5 class="card-title mb-0">
              <i class="fa fa-chart-bar me-2"></i>Monthly Revenue Overview
            </h5>
          </div>
          <div class="card-body">
            <div class="revenue-overview">
              <div class="revenue-highlight">
                <h3 class="text-success">{{ formatCurrency(dashboardStats.monthlyRevenue) }}</h3>
                <p class="text-muted">This Month's Revenue</p>
              </div>
              <div class="chart-placeholder">
                <div class="text-center py-4">
                  <i class="fa fa-chart-line fa-3x text-muted mb-3"></i>
                  <p class="text-muted">Revenue chart will be displayed here</p>
                  <small class="text-muted">Integration with charting library needed</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</div>
